module.exports = __webpack_public_path__ + "img/03.ab1f7d4c.png";